/** @jsxImportSource @emotion/react */
import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as snackbarActions from "../../../../actions/snackbarActions";
import PageTitle from "../../../Utils/smsTitle";
import { SubHeader } from "../../../../Containers/SubHeader";
import MainSnackbar from "../../../Utils/Snackbar/SmsSnackbar";
import ObGynSidebar from "../../Utils/ObGynSidebar";
import ObGynPatientInfo from "../../Utils/ObGynPatientInfo";
import { useGynaeConsultation } from "./hooks/useGynaeConsultation";
import { GynaeConsultationForm } from "./GynaeConsultationForm";
import { GynaeHistoryTimeline } from "./GynaeHistoryTimeline";
import {
    GYPageWrapper,
    GYTabContent,
    GYLoading,
} from "./GynaeConsultationStyles";
import { ObGynTabBar, ObGynTabBtn, ObGynTabBadge } from "../../Utils/ObGynTabStyles";

/* ═══════════════════════════════════════════════════════════════
   GynaeConsultationPage — Main page for Task 18:
   Gynaecological Consultation
   Tabs: Consultation | History
   Route: /gyn-and-obs-gynae-consultation/:patient_number/:visit_id/:patient_type
   ═══════════════════════════════════════════════════════════════ */

const GynaeConsultationPage = function (props) {
    const { actions, snackbar, match } = props;
    const { patient_number, visit_id, patient_type } = match.params;

    /* ── Current user ── */
    const user = JSON.parse(sessionStorage.getItem("user"));
    const userObj = !user ? {} : user;
    const token = !userObj.token ? [] : userObj.token;
    const _token = !token[1] ? {} : token[1];
    const user_roles_id = !_token.user_roles_id ? "" : _token.user_roles_id;

    /* ── Hook ── */
    const gyn = useGynaeConsultation(actions, patient_number, visit_id, user_roles_id);

    const closeSnackbar = function () { actions.snackbarActions.hideSnackbar(); };

    /* ── Loading ── */
    if (gyn.loading) {
        return (
            <div>
                <PageTitle title="Gynaecological Consultation" />
                <SubHeader title="OB/GYN" subTitle="Gynaecological Consultation" />
                <MainSnackbar variant={snackbar.variant} message={snackbar.message}
                    open={snackbar.open} handleCloseBar={closeSnackbar} />
                <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                    <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} patient_type={patient_type} />
                    <GYPageWrapper>
                        <GYLoading>Loading gynaecological consultation data...</GYLoading>
                    </GYPageWrapper>
                </ObGynSidebar>
            </div>
        );
    }

    return (
        <div>
            <PageTitle title="Gynaecological Consultation" />
            <SubHeader title="OB/GYN" subTitle="Gynaecological Consultation" />
            <MainSnackbar variant={snackbar.variant} message={snackbar.message}
                open={snackbar.open} handleCloseBar={closeSnackbar} />
            <ObGynSidebar patient_number={patient_number} visit_id={visit_id} patient_type={patient_type}>
                <ObGynPatientInfo patient_number={patient_number} visit_id={visit_id} patient_type={patient_type} />
                <GYPageWrapper>

                    {/* ─── Tab Bar ─── */}
                    <ObGynTabBar>
                        <ObGynTabBtn
                            active={gyn.activeTab === "consultation"}
                            onClick={function () { gyn.setActiveTab("consultation"); }}
                        >
                            Consultation
                        </ObGynTabBtn>
                        <ObGynTabBtn
                            active={gyn.activeTab === "history"}
                            onClick={function () { gyn.setActiveTab("history"); }}
                        >
                            History
                            <ObGynTabBadge active={gyn.activeTab === "history"}>
                                {gyn.consultations.length}
                            </ObGynTabBadge>
                        </ObGynTabBtn>
                    </ObGynTabBar>

                    {/* ─── Tab Content ─── */}
                    <GYTabContent>
                        {gyn.activeTab === "consultation" && (
                            <GynaeConsultationForm gyn={gyn} />
                        )}

                        {gyn.activeTab === "history" && (
                            <GynaeHistoryTimeline gyn={gyn} />
                        )}
                    </GYTabContent>

                </GYPageWrapper>
            </ObGynSidebar>
        </div>
    );
};

/* ─── Redux Connect ─── */
function mapStateToProps(state) {
    return { snackbar: state.snackbar };
}

function mapDispatchToProps(dispatch) {
    return { actions: { snackbarActions: bindActionCreators(snackbarActions, dispatch) } };
}

export default connect(mapStateToProps, mapDispatchToProps)(GynaeConsultationPage);
